<template>
  <v-container fluid>
    <v-row row>
      <v-col class="s8 input-field no-margins">

        <!-- <FullScreenLoad message="Loading Data" :value=showWait></FullScreenLoad> -->

        <div v-if="!valid">
          This page is not valid for this site group
        </div>
        
        <div v-else align="center">
          <v-card>
            <v-card-title>Summary Performance ({{last_run}})</v-card-title>
            <v-card-subtitle></v-card-subtitle>

            <v-card-text>

              <v-row row class="hidden-md-and-down">
                <v-col class="s8 input-field no-margins">

                  <v-data-table :headers="headers" 
                    :loading="showWait"
                    loading-text="Loading... Please wait"
                    
                    :items="data"
                    dense
                    hide-default-footer
                    hide-default-header
                    :items-per-page=items_per_page
                    :search="search" >

                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                      <tr>
                        <th style="text-align: center;" v-for="header in headers" v-bind:key="header.value">
                          <div>
                          {{ header.text }}
                          <br />
                          {{ header.units }}
                          </div>
                        </th>
                      </tr>
                      </thead>
                    </template>

                    <template v-slot:item="{ item }"> 

                      <tr>
                        <td align="center" v-for="(field, i) in item" v-bind:key="i"><v-chip :color=field[1]>{{ field[0] }}</v-chip></td>
                      </tr>
    
                    </template> 

                  </v-data-table>
                </v-col>
              </v-row>

            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <br>

    <template>
      <div>
        <v-btn color="primary" dark @click="get_log()">Show Log</v-btn>
        <br>
        
          <v-card v-if="showLog" >
            <v-card-title>Log</v-card-title>
            <v-card-subtitle></v-card-subtitle>

            <v-card-text>

              <v-textarea rows="10" v-model="log_data"></v-textarea>

            </v-card-text>
          </v-card>
        
      </div>
    </template>

  </v-container>
</template>

<script lang="ts">

import { Component, Ref, Vue } from 'vue-property-decorator';
import FaceRating from '@/components/FaceRating.vue';

import { strip_surrounding_quotes } from '../main';
import FullScreenLoad from '@/components/FullScreenLoad.vue';
import * as common from '@/common';
import { DateTime } from "luxon";

@Component({
  components: {
    FaceRating,
    FullScreenLoad,
  },
})
export default class PerformanceManager extends Vue {

  public $refs!: {
    form: any;
  };

  private headers: object[] = [];

  private valid: boolean = false;
  private items_per_page: number = -1;
  private data: any[] = [];
  private search: string = '';
  private log_data: string = '';
  private showLog: boolean = false;
  private showWait: boolean = true;
  private automode: [number, string, string, string] = [-1, 'red', 'Unknown Error', 'mdi-radiator-off'];
  private json_data: string = '';
  private last_run: string = '';

  private colours: Map<string, string> = new Map();

  public async created() {
    const self = this;

    self.colours = new Map([
      ['OK', 'green'],
      ['!', 'orange'],
      ['!!!', 'red'],
    ]);
  }

  public async mounted() {

    const self = this;

    self.update();

    this.$store.watch(
      (state) => {
        return this.$store.state.currentSiteGroup; // could also put a Getter here
      },
      (newValue, oldValue) => {

        self.update();
      },
    );
  }

  public async update() {
    const self = this;

    console.log('mounted Performance');
    
    self.data = [];
    self.headers = [];
    
    try {
      self.json_data = await self.$store.dispatch('requestStaticFileForSiteGroupId', {"product": "tagged_performance_generator", "filename": "performance.json"}, {timeout: 30000}); 

      if(self.json_data) {
        self.valid = true;
      }
    
      const lines = self.json_data.split('\n');

      const last_run_header = lines[0];

      const last_time_str = JSON.parse(last_run_header)['last_run'];

      // 2022-07-11T11:05:06 +0100
      const dt = DateTime.fromFormat(
                last_time_str,
                "yyyy-MM-dd'T'HH:mm:ss ZZZ"
              );
                
      self.last_run = dt.toFormat('dd-MM-yyyy HH:mm');

      const header_fields = Object.keys(JSON.parse(lines[1]));

      let count = 0;
      for (const field of header_fields) {
        self.headers.push({text: field, units: '', align: 'center', value: count.toString()});
        count++;
      }

      for (const line of lines.slice(1)) {

        if(line === undefined || line === "") {
          continue;
        }

        const line_json = JSON.parse(line);

        const item_obj = {};
        count = 0;
        for (const field_name of header_fields) {

          const field = line_json[field_name];
          // alert(field);
          let val_and_colour = self.parse_field(field);

          if (count == 0) {
            // Site name
            // Transparent background
            val_and_colour = self.parse_field(field, 'rgba(100, 100, 100, 0)');
          }

          // console.log(val_and_colour);

          item_obj[count.toString()] = val_and_colour; // {display: val_and_colour[0], colour: val_and_colour[1] };
          count++;
        }

        self.data.push(item_obj);
      }

      console.log(self.data);

      self.showWait = false;
    }
    catch {
      self.valid = false;
    }
  }

  // public getColor(item: IHousePerformanceDataValue): string {
  //   return item.style['background-color'];
  // }

  public link(reference: string): string {
    return '/#/portfolio_details/' + reference;
  }

  public validate() {
    this.$refs.form.validate();
  }

  public reset() {
    this.$refs.form.reset();
  }

  public resetValidation() {
    this.$refs.form.resetValidation();
  }

  protected async getRefsFromSiteGroupSitesAndNamesPayload(): Promise<object> {
    return {requested_site_group_namespace: 'bryn_bragl', point_names: ['downstairs_sockets_energy', 'upstairs_sockets_energy', 'kitchen_sockets_energy',
                        'actual_room_temp', 'heating_energy', 'dhw_volume']};
  }

  private async get_log() {
    const self = this;
    
    if (self.showLog) {
      self.showLog = false;
      return;
    }

    try {
      self.log_data = await self.$store.dispatch('requestStaticFileForSiteGroupId', {"product": "tagged_performance_generator", "filename": "/status_events/journal.dat"}, {timeout: 30000}); 
      self.log_data = self.log_data.split('\n').reverse().join('\n');
      self.showLog = true;
    }
    catch {
      
    }
  }

  private isFloat(s: string): boolean {
    var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
    if (floatRegex.test(s))
        return true;

    // Handle scientifc notation ?
    const val = parseFloat(s);
    if (isNaN(val))
        return false;
    return true;
  }

  private parse_float_or_str(s: string, default_string: string): string {

    if (this.isFloat(s)) {
      return parseFloat(s).toFixed(1);
    }

    s = s.trim();

    if (s === "None") {
      s = default_string;
    }

    return s;
  }

  private parse_field(s: any, default_colour='rgba(100, 100, 100, 1)'): [string, string] {

    const self = this;

    if (s === undefined || s === null) {
      return ['unknown', 'unknown'];
    }

    if (typeof s === 'string' || s instanceof String) {
      s = s.trim();
    }

    if (Array.isArray(s)) {
      return [self.parse_float_or_str(s[0], s[1]), self.colours.get(s[1])!];
    }

    // console.log("typeof s: ", typeof s, s)

    // Normal float or string
    const tmp: [string, string] = [self.parse_float_or_str(s, s), default_colour];
    // console.log('tmp:', tmp);
    return tmp;
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="css">

</style>